import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, SparklesIcon, ClockIcon, AwardIcon } from 'lucide-react';
export function About() {
  const features = [{
    icon: ClockIcon,
    title: 'Horneado Diario',
    description: 'Productos frescos cada mañana'
  }, {
    icon: SparklesIcon,
    title: 'Recetas Artesanales',
    description: 'Tradición en cada preparación'
  }, {
    icon: AwardIcon,
    title: 'Calidad Premium',
    description: 'Los mejores ingredientes'
  }, {
    icon: HeartIcon,
    title: 'Atención Cálida',
    description: 'Servicio con excelencia'
  }];
  return <section id="nosotros" className="py-20 bg-secondary-cream" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-3">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-4">
            <img src="https://images.unsplash.com/photo-1555507036-ab1f4038808a?w=800&q=80" alt="Interior de panadería" className="rounded-2xl shadow-2xl" data-id="element-5" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-6">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-secondary-brown mb-6" data-id="element-7">
              Quiénes Somos
            </h2>
            <p className="text-lg text-secondary-brown-light mb-6 leading-relaxed" data-id="element-8">
              La Victoria II es una franquicia nueva que nace de la pasión por
              la panadería artesanal y el compromiso con la calidad premium.
              Cada día horneamos con dedicación, siguiendo recetas tradicionales
              y utilizando los mejores ingredientes.
            </p>
            <p className="text-lg text-secondary-brown-light mb-8 leading-relaxed" data-id="element-9">
              Nuestra misión es ofrecer productos frescos con excelencia en cada
              detalle, brindando una atención cálida que hace de cada visita una
              experiencia memorable. Somos tradición, calidad y sabor en cada
              bocado.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}